module.exports = __webpack_public_path__ + "quotezone-ui/img/central-rail-white.f9fc021f.gif";